export const fourthStepFormValues = {
    username: '',
    password: '',
  confirmpassword: '',
  checkpoliticas: false,
  checkComunicaciones: false,
  }